/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */


const swiper = new Swiper('.mega-menu-slider', {
    loop: false,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    slidesPerView: 5,
    paginationClickable: true,
    freeMode: true,
    direction: 'horizontal',
    mousewheelControl: false,
    slidesPerGroup: 2,
    loopFillGroupWithBlank: false,
    breakpoints: {
        1920: {
            slidesPerView: 5
        },
        1023: {
            slidesPerView: 3
        },
        767: {
            slidesPerView: 2
        },
        480: {
            slidesPerView: 1
        }
    },
    mousewheel: {
      enabled: true,
      sensitivity: 4,
    }
});


// const panelDiv = document.querySelector('.mobile_first_link');
// if (panelDiv.classList.contains('hide_search_mobile')) {
//   const triggerDiv = document.querySelector('.tab_app_slideshow');
//   triggerDiv.classList.add('hide_in_mobile');
// }

const clickButton = document.querySelector(".mobile_first_link");
const collapsibleContent = document.querySelector('.drawer__content > .mobile-nav > .mobile-nav__item:first-child > collapsible-content');
if(clickButton){
  clickButton.addEventListener("click", (event) => {
      document.querySelector(".burger_menu").click();
      if (!collapsibleContent.hasAttribute('open')) {
          document.querySelector(".drawer__content > .mobile-nav > .mobile-nav__item:first-child > .mobile-nav__link").click();
      }
  });
}


// Collection Top Description Show/Hide
  const read_more_btn = document.querySelector(".down_up_arrow1 span");
  const clickcollectionText = document.querySelector(".collection__description");
  if(clickcollectionText){
    read_more_btn.addEventListener("click", (event) => {
      if(event.currentTarget == read_more_btn ){
        if(clickcollectionText.innerText.length > 47){
          clickcollectionText.classList.toggle("show");
        }
        if(clickcollectionText.classList.contains('show')){
          read_more_btn.innerText = "Read Less";
        } else{
          read_more_btn.innerText = "Read More";
        }
        event.preventDefault();
      }
    });
  }

// Clickable Header Menu






// document.addEventListener("DOMContentLoaded", function() {
//     var productFacet = document.querySelector('.product-facet');
//     if (productFacet && productFacet.classList.contains('product-facet-filter-top')) {
//         const items = document.querySelectorAll('.product-facet__filter-item .collapsible-toggle');
//         items.forEach(item => {
//             item.setAttribute('aria-expanded', 'false');
//         });
//     }
// });



// app dropdown active class
  document.addEventListener('DOMContentLoaded', function () {
    function attachSelectListeners() {
      document.querySelectorAll('.easysearch-select-holder select').forEach(function (select) {
        const holder = select.closest('.easysearch-select-holder');

        // Prevent rebinding
        if (select.dataset.listenerAttached === 'true') return;

        // Flag to detect if dropdown is open
        let isOpen = false;

        // On mousedown, toggle open state
        select.addEventListener('mousedown', function (e) {
          // If already open, close it and remove class manually
          if (isOpen) {
            isOpen = false;
            holder.classList.remove('active');
          } else {
            // Otherwise, let focus handle adding class
            isOpen = true;
            holder.classList.add('active');
          }
        });

        // Remove active class on blur (when dropdown closes)
        select.addEventListener('blur', function () {
          isOpen = false;
          holder.classList.remove('active');
        });

        select.dataset.listenerAttached = 'true';
      });
    }

    // Bind immediately and watch for app-generated content
    attachSelectListeners();

    const observer = new MutationObserver(function () {
      attachSelectListeners();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });

  ////custom filter hide
  document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => {
    const preSelectValue = easysearch.preSelect?.[0]; 
    const selectElement = document.querySelector('.easysearch-select-holder select');
    const productList = document.querySelector('.product-facet__product-list');

    if (!selectElement || !productList) return; 

    const collectionValue = productList.getAttribute('data-collection');
    const selectedValue = selectElement.value;
    const matched = Array.from(selectElement.options).filter((option,index)=>{
      if(index == 0){}else{return option.value === collectionValue || option.value === selectedValue}
    });
    for (const option of selectElement.options) {
      if(matched.length > 0){
        option.style.display = (option.value === collectionValue || option.value === selectedValue) ? 'block': 'none';
      } else{
        option.style.display = 'block';
      }
    }
  }, 500);
});

// Click To Scroll Js Start

document.querySelector('.bundle-btn').addEventListener('click', function(e) {
  e.preventDefault();
  const target = document.querySelector('#bundle-upsell-section');
  const header = document.querySelector('.shopify-section--header');
  const sticky = document.querySelector('.product-sticky-form');
  if (!target) return;
  const headerHeight = header ? header.offsetHeight : 0;
  const stickyHeight = sticky ? sticky.offsetHeight : 0;
  const totalOffset = headerHeight + stickyHeight;
  const targetPosition = target.getBoundingClientRect().top + window.scrollY - totalOffset;
  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
  history.replaceState(null, '', window.location.pathname + window.location.search);
});

// Click To Scroll Js End